<template>
  <AdminModal :title="`Pagos · ${row.name}`" wide @close="$emit('close')">
    <p v-if="loading" class="ad-empty">Cargando…</p>
    <p v-else-if="error" class="ad-error">{{ error }}</p>
    <p v-else-if="!payments.length" class="ad-empty">Este parque aún no tiene pagos registrados.</p>
    <div v-else class="ad-table-wrap">
      <table class="hist">
        <thead><tr><th>Fecha</th><th>Monto</th><th>Meses</th><th>Plan</th><th>Método</th><th>Referencia</th><th>Registró</th></tr></thead>
        <tbody>
          <tr v-for="p in payments" :key="p.id">
            <td>{{ formatDate(p.paidAt) }}</td>
            <td class="ad-mono">{{ money(p.amount) }}</td>
            <td>{{ p.months }}</td>
            <td>{{ p.planName }}</td>
            <td>{{ PAYMENT_METHODS[p.method] || '—' }}</td>
            <td>{{ p.reference || '—' }}<span v-if="p.note" class="ad-hint" :title="p.note"> · nota</span></td>
            <td>{{ p.registeredBy }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <template #footer>
      <button type="button" class="ad-btn ad-btn--ghost" @click="$emit('close')">Cerrar</button>
    </template>
  </AdminModal>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import AdminModal from './AdminModal.vue'
import { getParkPayments } from '@/services/superadmin'
import { errorText, formatDate, money, PAYMENT_METHODS } from './adminFormat'

const props = defineProps({ row: { type: Object, required: true } })
defineEmits(['close'])

const payments = ref([])
const loading = ref(true)
const error = ref('')

onMounted(async () => {
  try {
    payments.value = await getParkPayments(props.row.id)
  } catch (err) {
    error.value = errorText(err, 'No se pudo cargar el historial.')
  } finally {
    loading.value = false
  }
})
</script>

<style scoped>
.hist { width: 100%; border-collapse: collapse; min-width: 520px; }
.hist th { text-align: left; font: 600 11px Inter, sans-serif; color: #64748b; padding: 6px 8px; border-bottom: 1px solid #e8edf4; white-space: nowrap; }
.hist td { padding: 8px; border-bottom: 1px solid #f1f5f9; font: 400 12px Inter, sans-serif; color: #475569; }
</style>